import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};

export const ArbitrumIcon = ({ width = 20, fill = '#677DE3' }: Props) => (
  <svg
    width="36"
    height="40"
    viewBox="0 0 36 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.61914 12.1592V27.8408C1.61914 28.842 2.15422 29.7677 3.02086 30.2667L16.6015 38.1091C17.4681 38.6081 18.535 38.6081 19.4017 38.1091L32.9823 30.2667C33.8489 29.7677 34.384 28.842 34.384 27.8408V12.1592C34.384 11.158 33.8489 10.2322 32.9823 9.73326L19.4017 1.89083C18.535 1.39186 17.4681 1.39186 16.6015 1.89083L3.01758 9.73326C2.15094 10.2322 1.61914 11.158 1.61914 12.1592Z"
      fill="black"
    />
    <path
      d="M20.9645 23.0416L19.0277 28.3531C18.9752 28.5008 18.9752 28.6617 19.0277 28.8094L22.3596 37.9485L26.2136 35.7228L21.5882 23.0416C21.4832 22.7495 21.0695 22.7495 20.9645 23.0416Z"
      fill="white"
    />
    <path
      d="M24.848 14.1093C24.7429 13.8171 24.3293 13.8171 24.2242 14.1093L22.2874 19.4207C22.2349 19.5684 22.2349 19.7293 22.2874 19.877L27.7466 34.8397L31.6005 32.614L24.848 14.1093Z"
      fill="white"
    />
    <path
      d="M18.0002 2.47846C18.0954 2.47846 18.1905 2.50472 18.2759 2.55068L32.9727 11.0365C33.1434 11.135 33.2484 11.3188 33.2484 11.5125V28.4809C33.2484 28.6779 33.1434 28.8584 32.9727 28.9569L18.2759 37.4428C18.1938 37.492 18.0954 37.515 18.0002 37.515C17.905 37.515 17.8098 37.4887 17.7244 37.4428L3.02764 28.9635C2.85694 28.865 2.75189 28.6812 2.75189 28.4875V11.5158C2.75189 11.3188 2.85694 11.1383 3.02764 11.0398L17.7244 2.55396C17.8098 2.50472 17.905 2.47846 18.0002 2.47846ZM18.0002 0C17.4782 0 16.953 0.134592 16.4835 0.407058L1.79006 8.88962C0.851197 9.43127 0.273438 10.4325 0.273438 11.5158V28.4842C0.273438 29.5675 0.851197 30.5687 1.79006 31.1104L16.4868 39.5962C16.9562 39.8654 17.4782 40.0033 18.0034 40.0033C18.5254 40.0033 19.0506 39.8687 19.5201 39.5962L34.2168 31.1104C35.1557 30.5687 35.7334 29.5675 35.7334 28.4842V11.5158C35.7334 10.4325 35.1557 9.43127 34.2168 8.88962L19.5168 0.407058C19.0473 0.134592 18.5221 0 18.0002 0Z"
      fill="white"
    />
    <path
      d="M8.27979 34.8592L9.63227 31.1562L12.3536 33.418L9.80954 35.7422L8.27979 34.8592Z"
      fill="black"
    />
    <path
      d="M16.7623 10.3013H13.0364C12.7573 10.3013 12.5078 10.4753 12.4127 10.7379L4.42578 32.6336L8.2797 34.8593L17.0741 10.7477C17.1562 10.5311 16.9953 10.3013 16.7623 10.3013Z"
      fill="white"
    />
    <path
      d="M23.282 10.3013H19.5561C19.2771 10.3013 19.0276 10.4753 18.9324 10.7379L9.81299 35.7391L13.6669 37.9648L23.5939 10.7477C23.6727 10.5311 23.5118 10.3013 23.282 10.3013Z"
      fill="white"
    />
  </svg>
);
